import React, { useState } from "react";
import { ReactComponent as ItemButton } from "assets/icons/topbar_item_button.svg";
import { ReactComponent as BellIcon } from "assets/icons/bell.svg";
import { ReactComponent as FilterMobile } from "assets/icons/mobile_filter.svg";
import SearchSaveDialog from "components/Dialog/SearchSaveDialog";
import useSearchFilter from "hooks/useSearchFilter";
import HousePriceCalculatorDialog from "components/Dialog/HousePriceCalculatorDialog";

const SearchMobileFilter = () => {
  const [isSaveSearchDialogOpen, setIsSaveSearchDialogOpen] = useState(false);
  const { toggleSearchMobileFilterDialog, toggleHousePriceCalculatorDialog } =
    useSearchFilter();

  return (
    <div className="bg-white justify-between flex  space-x-[7.5px] pb-[14px] md:pb-0">
      <div className="flex items-center space-x-[7.5px]">
        <div
          onClick={toggleSearchMobileFilterDialog}
          className={`inline-flex lg:hidden bg-white text-black items-center justify-between min-w-fit xs:space-x-3 px-[14px] cursor-pointer h-[42px] rounded-[8px] border border-[#F0EFFB] hover:bg-[#EAEAEA] transition-all duration-300 ease-in `}
        >
          <h2
            className={`font-semibold hidden xs:block flex-shrink-0 leading-none text-[12px] text-black `}
          >
            Seleziona Filtri
          </h2>
          <FilterMobile />
        </div>
        <div
          onClick={() =>
            toggleHousePriceCalculatorDialog("searchCalculatorMobile")
          }
          className="cursor-pointer w-[42px] h-[42px] flex items-center justify-center  rounded-[8px] border-[1.5px] border-[#F0EFFB]"
        >
          <ItemButton />
        </div>
      </div>
      <div
        onClick={() => setIsSaveSearchDialogOpen(true)}
        className="flex items-center justify-center space-x-[6px] cursor-pointer bg-[#FF6D59] rounded-[8px] h-[42px] w-[141px] hover:opacity-90 transition-all duration-300"
      >
        <BellIcon />
        <p className="text-[12px] flex-shrink-0 font-semibold leading-[30px] text-white">
          Salva la Ricerca
        </p>
      </div>
      <HousePriceCalculatorDialog id="searchCalculatorMobile" />

      <SearchSaveDialog
        isOpen={isSaveSearchDialogOpen}
        onClose={() => setIsSaveSearchDialogOpen(false)}
      />
    </div>
  );
};

export default SearchMobileFilter;
